<template>
    <div>

        <div
            class="popup-laterale popup-galleria-foto-1 bg-white d-flex flex-column"
            v-if="step === 'articlesList'"
        >
            <header
                role="navigation"
                class="navbar navbar-expand navbar-light"
            >
                <nav class="flex-grow-1">
                    <div class="pulsante-indietro navbar-nav align-items-center text-uppercase">
                        <a
                            class="d-none nav-item nav-link"
                            @click="back()"
                        >
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />
                            {{ $t("Indietro") }}
                        </a>
                    </div>
                </nav>
                <a
                    href="#"
                    class="nav-link pr-2 pl-2 close-link"
                    @click.prevent="close"
                >
                    <button
                        type="button"
                        class="close d-inline-flex align-items-center"
                        aria-label="Close"
                    >
                        <font-awesome-icon :icon="['fas', 'times']" />
                        <span class="d-none d-sm-inline ml-1 small font-weight-normal text-uppercase">{{$t("Chiudi")}}</span>
                    </button>
                </a>
            </header>

            <div class="container-fluid flex-grow-1">
                <h2 class="titolo-popup mt-3 mb-0 text-center text-uppercase">
                    {{ $t("Scegli un prodotto") }}
                </h2>
                <div
                    class="anteprima-foto mt-4 text-center"
                    v-if="photoData.id"
                >
                    <img
                        :src="getUrl(photoData.id)"
                        alt=""
                        class="mw-100"
                    />
                </div>

                <ul class="categorie-prodotti mt-4 nav nav-tabs d-flex flex-row justify-content-center">
                    <li
                        class="nav-item"
                        v-for="(group, index) in groups"
                        :key="index"
                    >
                        <a
                            class="nav-link text-uppercase font-weight-bold"
                            :class="{ active: index === activeGroup }"
                            :id="group.name + '-tab'"
                            data-toggle="tab"
                            role="tab"
                            :aria-controls="group.name"
                            aria-selected="true"
                            @click="selectGroup(index)"
                        >
                            {{ group.name }}
                        </a>
                    </li>
                </ul>

                <div class="prodotti tab-content nav-tabs text-center">
                    {{ activeGroupDescription }}
                </div>

                <div class="prodotti tab-content mt-2">
                    <div
                        class="tab-pane fade show"
                        v-for="(group, index) in groups"
                        :key="index"
                        :class="{ active: index === activeGroup }"
                        :id="index+'-'+group.name"
                        role="tabpanel"
                        :aria-labelledby="group.name + '-tab'"
                    >
                        <ul class="mb-3">
                            <li
                                class="prodotto border-bottom"
                                v-for="groupArticle in group.articles"
                                :key="groupArticle.code"
                                @click="selectArticle(groupArticle)"
                            >
                                <a class="py-2 d-flex flex-row justify-content-between align-items-center">
                                    <span class="nome-prodotto d-inline-block flex-grow-1 pr-2">
                                        {{ groupArticle.name }}
                                    </span>
                                    <span
                                        class="quantita-prodotto d-inline-block pr-2"
                                        v-if="groupArticle.quantity > 0"
                                    >
                                        {{ groupArticle.quantity }} nel carrello
                                    </span>
                                    <span class="prezzo-prodotto d-inline-block px-2">
                                        {{
                                            parseFloat(groupArticle.price)
                                                | toCurrency
                                        }}
                                    </span>
                                    <span class="d-inline-block pl-2">
                                        <font-awesome-icon :icon="['fas', 'caret-right']" />
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <footer
                class="bg-light mt-3 py-3"
                v-show="
                    !!this.cartPhotoState && this.cartPhotoState.numInCart > 0
                "
            >
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div class="riepilogo-carrello col-5 col-sm-7 col-md-8">
                            <p class="totale mb-0 font-weight-bold">
                                <span class="text-blurikorda font-titoli-rikorda">{{
                                    this.cartPhotoState.subTotal | toCurrency
                                }}</span>
                            </p>

                            <p class="numero-prodotti-carrello mb-0 mt-1">
                                {{ this.cartPhotoState.numInCart }}
                                {{ $t("prodotti nel carrello") }}
                            </p>
                        </div>
                        <div class="contenitore-pulsante-vai-a-carrello text-right col-7 col-sm-5 col-md-4">
                            <a
                                class="btn btn-dark pulsante-vai-a-carrello btn-rikorda2-alt"
                                @click="goToCart()"
                            >{{
                                $t("Vai al carrello")
                            }}</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>

        <div
            class="popup-laterale popup-galleria-foto-2 bg-white d-flex flex-column"
            v-if="step === 'article'"
        >
            <header
                role="navigation"
                class="navbar navbar-expand navbar-light"
            >
                <nav class="flex-grow-1">
                    <div class="pulsante-indietro navbar-nav align-items-center text-uppercase">
                        <a
                            class="nav-item nav-link"
                            @click="back()"
                        >
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />
                            {{ $t("Indietro") }}
                        </a>
                    </div>
                </nav>
                <a
                    href="#"
                    class="nav-link pr-2 pl-2 close-link"
                    @click.prevent="close"
                >
                    <button
                        type="button"
                        class="close d-inline-flex align-items-center"
                        aria-label="Close"
                    >
                        <font-awesome-icon :icon="['fas', 'times']" />
                        <span class="d-none d-sm-inline ml-1 small font-weight-normal text-uppercase">{{$t("Chiudi")}}</span>
                    </button>
                </a>
            </header>

            <div class="container-fluid flex-grow-1">
                <h2 class="titolo-popup mt-3 mb-0 text-center text-uppercase">
                    {{ selectedArticle.name }}
                </h2>
                <p class="prezzo-prodotto mt-1 mb-0 text-center">
                    {{ parseFloat(selectedArticle.price) | toCurrency }}
                </p>

                <div
                    class="anteprima-foto mt-4 text-center"
                    v-if="photoData.id"
                >
                    <img
                        :src="getUrl(photoData.id)"
                        alt=""
                        class="mw-100"
                    />
                </div>

                <div class="selezione-quantita mt-3 mb-3">
                    <div class="row justify-content-center align-items-center text-center">
                        <div class="form-group mb-0 mr-3">
                            <label
                                class="d-block"
                                for="quantita"
                            >
                                {{ $t("Quantità") }}
                            </label>
                            <div class="input-quantita custom-control-inline mr-0">
                                <button
                                    class="btn btn-dark btn-rikorda2 rounded-circle mr-2"
                                    @click.prevent="changeSelectedArticleQuantity(-1)"
                                >
                                    <font-awesome-icon :icon="['fas', 'minus']" />
                                </button>

                                <input
                                    type="number"
                                    id="quantita"
                                    name="quantita"
                                    min="1"
                                    class="text-center"
                                    v-model="selectedArticleQt"
                                />

                                <button
                                    class="btn btn-dark btn-rikorda2 rounded-circle ml-2"
                                    @click.prevent="changeSelectedArticleQuantity(1)"
                                >
                                    <font-awesome-icon :icon="['fas', 'plus']" />
                                </button>
                            </div>
                        </div>

                        <div class="form-group mb-0 ml-3">
                            <label class="d-block">{{ $t("Subtotale") }}</label>

                            <div class="output-subtotale custom-control-inline mr-0">
                                <p class="d-inline-flex align-items-center mb-0 font-weight-bold">
                                    <span class="font-titoli-rikorda">{{ selectedArticleSubtotal | toCurrency }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer class="bg-light mt-3 py-3">
                <div class="container-fluid text-center d-flex justify-content-center flex-wrap">
                    <a
                        @click="removeFromCart"
                        v-show="selectedArticle.quantity > 0"
                        class="btn btn-dark pulsante-rimuovi-da-carrello btn-rikorda2 mt-1 mb-1 mx-1 mx-sm-2"
                    >
                        {{ $t("Rimuovi dal carrello") }}
                    </a>

                    <a
                        class="btn btn-dark pulsante-aggiungi-a-carrello btn-rikorda1 btn-icon-right mt-1 mb-1 mx-1 mx-sm-2"
                        @click="addToCart"
                    >{{
                                  $t("Aggiungi al carrello")
                              }}
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </a>
                </div>
            </footer>
        </div>

        <div
            class="popup-laterale popup-galleria-foto-3 bg-white d-flex flex-column"
            v-if="step === 'added-to-cart'"
        >
            <header
                role="navigation"
                class="navbar navbar-expand navbar-light"
            >
                <nav class="flex-grow-1">
                    <div class="pulsante-indietro navbar-nav align-items-center text-uppercase">
                        <a
                            class="d-none nav-item nav-link"
                            @click="back()"
                        >
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />
                            {{ $t("Indietro") }}
                        </a>
                    </div>
                </nav>
                <a
                    href="#"
                    class="nav-link pr-2 pl-2 close-link"
                    @click.prevent="close"
                >
                    <button
                        type="button"
                        class="close d-inline-flex align-items-center"
                        aria-label="Close"
                    >
                        <font-awesome-icon :icon="['fas', 'times']" />
                        <span class="d-none d-sm-inline ml-1 small font-weight-normal text-uppercase">{{$t("Chiudi")}}</span>
                    </button>
                </a>
            </header>

            <div class="container-fluid flex-grow-1 mt-3">
                <div class="icon-addtocart-success text-center px-4 pt-4 pb-2 text-success">
                    <font-awesome-icon :icon="['fas', 'check-circle']" />
                </div>

                <h2 class="titolo-popup text-center text-uppercase px-4 pb-4 pt-2 mb-0">
                    {{ $t("L'articolo è stato aggiunto al carrello") }}
                </h2>

                <div class="text-center mt-4">
                    <button
                        class="btn btn-primary pulsante-carrello btn-rikorda1 btn-icon-right"
                        @click="goToCart()"
                    >
                        {{ $t("Vai al carrello") }}
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </button>
                </div>

                <div class="text-center mt-4">
                    <button
                        class="btn btn-outline-primary pulsante-continua-shopping btn-rikorda2 btn-icon-right"
                        @click="back()"
                    >
                        {{ $t("Aggiungi altri articoli") }}
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </button>
                </div>
            </div>

            <footer></footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArticlesModal",
    props: ["favorites"],

    data() {
        return {
            mode: "single-photo",
            step: "articlesList",
            photoData: {},
            cartPhotoState: {},
            groups: [],
            groupsNames: [],
            activeGroup: 0,
            selectedArticle: {},
            tempCartPhotoState: {},
            numPhotos: 0,
            selectedArticleQt: 1
        };
    },

    computed: {
        activeGroupDescription() {
            if (
                this.groups &&
                this.groups[this.activeGroup] &&
                this.groups[this.activeGroup].description
            )
                return this.groups[this.activeGroup].description;
            return "";
        },

        selectedArticleSubtotal() {
            var selectedArticleSubtotal = 0;
            if (this.selectedArticleQt) {
                switch (this.mode) {
                    case "single-photo":
                        selectedArticleSubtotal =
                            this.selectedArticleQt * this.selectedArticle.price;
                        break;
                    case "all-photos":
                        selectedArticleSubtotal =
                            this.selectedArticleQt *
                            this.selectedArticle.price *
                            this.numPhotos;
                        break;
                }
            }
            return selectedArticleSubtotal;
        },
        subTotal() {
            var subTotal = 0;
            if (this.selectedArticleQt) {
                switch (this.mode) {
                    case "single-photo":
                        subTotal =
                            this.tempCartPhotoState.subTotal +
                            this.selectedArticleQt * this.selectedArticle.price;
                        break;
                    case "all-photos":
                        subTotal =
                            this.selectedArticleQt *
                            this.selectedArticle.price *
                            this.numPhotos;
                        break;
                }
            }
            return subTotal;
        }
    },

    mounted() {
        console.debug("ARTICLESMODAL");
    },

    methods: {
        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "event-web", true);
        },

        getPriceSheetData() {
            this.cartPhotoState = { numInCart: 0, subTotal: 0 };
            this.groups = [];
            this.groupsNames = [];
            this.activeGroup = 0;
            this.selectedArticle = {};
            this.tempCartPhotoState = {};
            this.mode = Object.prototype.hasOwnProperty.call(
                this.photoData,
                "id"
            )
                ? "single-photo"
                : "all-photos";
            var photoId = this.mode === "single-photo" ? this.photoData.id : [];
            return this.$api
                .getPriceSheetData(photoId)
                .then((data) => {
                    console.debug("GET_PRICE_SHEET_DATA", data);
                    if (this.mode === "single-photo") {
                        this.cartPhotoState = data.cartPhotoState;
                    }
                    this.groups = data.groups;
                    this.activeGroup = 0;
                    return true;
                })
                .catch((error) => {
                    console.error(error);
                    return false;
                });
        },

        selectGroup(index) {
            this.activeGroup = index;
        },

        selectArticle(article) {
            this.selectedArticle = Object.assign({}, article);
            this.selectedArticleQt = this.selectedArticle.quantity
                ? parseInt(this.selectedArticle.quantity)
                : 0;
            this.selectedArticle.price = parseFloat(this.selectedArticle.price);
            this.tempCartPhotoState = Object.assign({}, this.cartPhotoState);
            if (this.selectedArticleQt > 0) {
                this.tempCartPhotoState.numInCart -= this.selectedArticleQt;
                this.tempCartPhotoState.subTotal -=
                    this.selectedArticleQt * this.selectedArticle.price;
            } else {
                this.selectedArticleQt = 1;
            }
            this.step = "article";
        },

        changeSelectedArticleQuantity(change) {
            var quantity = this.selectedArticleQt + change;
            if (quantity > 0) {
                this.selectedArticleQt = quantity;
            }
        },

        addToCart() {
            var promise = null;
            if (this.mode === "single-photo") {
                promise = this.$store.dispatch("ADD_ITEM_TO_CART", {
                    photoId: this.photoData.id,
                    articleCode: this.selectedArticle.code,
                    quantity: this.selectedArticleQt,
                    projectId: null
                });
            } else {
                promise = this.$store.dispatch("ADD_ALL_PHOTOS_TO_CART", {
                    articleCode: this.selectedArticle.code,
                    quantity: this.selectedArticleQt,
                    onlyFavorites: this.favorites
                });
            }

            promise
                .then((result) => {
                    console.debug("ADD_ITEM_TO_CART", result);
                    this.step = "added-to-cart";
                    this.$emit(
                        "addedToCart",
                        this.mode === "single-photo" ? this.photoData : null
                    );
                })
                .catch((error) => {
                    console.error("ADD_ITEM_TO_CART", error);
                });
        },

        removeFromCart() {
            // TODO: manca rimozione al carrello
            var promise = null;
            if (this.mode === "single-photo") {
                promise = this.$store.dispatch("REMOVE_ITEM_FROM_CART", {
                    photoId: this.photoData.id,
                    articleCode: this.selectedArticle.code
                });
            }

            promise
                .then((result) => {
                    console.debug("REMOVE_ITEM_FROM_CART", result);
                    this.$emit(
                        "removedFromCart",
                        this.mode === "single-photo" ? this.photoData : null
                    );
                })
                .catch((error) => {
                    console.error("REMOVE_ITEM_FROM_CART", error);
                })
                .finally(() => {
                    this.back();
                });
        },

        back() {
            switch (this.step) {
                case "articlesList":
                    this.close();
                    break;
                case "article":
                case "added-to-cart":
                    this.getPriceSheetData().then((response) => {
                        if (response) {
                            this.step = "articlesList";
                        }
                    });
                    break;
            }
        },

        close() {
            this.step = "articlesList";
            this.photoData = {};
            this.$emit("close");
        },

        goToCart() {
            this.$router.push({
                name: "gallery-cart",
                params: { galleryUrl: this.$route.params.galleryUrl }
            });
        }
    }
};
</script>

<style></style>
